var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tabList.length < 1
    ? _c("empty", { attrs: { value: _vm.value } })
    : _c("div", { staticClass: "movie_nav_inner" }, [
        _c(
          "div",
          { staticClass: "tabs" },
          _vm._l(_vm.tabList, function (tab) {
            return _c(
              "div",
              {
                key: tab.type,
                class: ["tab", tab.type === _vm.activeTab && "active"],
                on: {
                  click: function ($event) {
                    return _vm.tabChange($event, tab)
                  },
                },
              },
              [_vm._v(" " + _vm._s(tab.name) + " ")]
            )
          }),
          0
        ),
        _vm.activeTab === "ciname"
          ? _c(
              "div",
              { staticClass: "ciname" },
              [
                _c("div", { staticClass: "screen" }, [
                  _c("div", { staticClass: "screenItem" }, [
                    _vm._v(" 区域 "),
                    _c("i", { staticClass: "el-icon el-icon-caret-bottom" }),
                  ]),
                  _c("div", { staticClass: "screenItem" }, [
                    _vm._v(" 品牌影城 "),
                    _c("i", { staticClass: "el-icon el-icon-caret-bottom" }),
                  ]),
                  _c("div", { staticClass: "screenItem" }, [
                    _vm._v(" 排序 "),
                    _c("i", { staticClass: "el-icon el-icon-caret-bottom" }),
                  ]),
                ]),
                Array.isArray(_vm.value.cinameList)
                  ? _vm._l(_vm.value.cinameList, function (item) {
                      return _c(
                        "div",
                        { key: item.id, staticClass: "cinameList" },
                        [
                          _c("div", { staticClass: "left" }, [
                            _c("div", { staticClass: "ciName" }, [
                              _vm._v(_vm._s(item.cinema_name)),
                            ]),
                            _c("div", { staticClass: "address" }, [
                              _vm._v(_vm._s(item.cinema_address)),
                            ]),
                          ]),
                          _c("div", { staticClass: "distance" }, [
                            _vm._v("200m"),
                          ]),
                        ]
                      )
                    })
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
        _vm.activeTab === "movie" && Array.isArray(_vm.value.movieList)
          ? _c(
              "div",
              { staticClass: "movie" },
              _vm._l(_vm.value.movieList, function (item) {
                return _c(
                  "div",
                  { key: item.id, staticClass: "movieList" },
                  [
                    _c("el-image", {
                      staticClass: "img",
                      attrs: { src: item.poster_horizon },
                    }),
                    _c("div", { staticClass: "movieInfo" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(" " + _vm._s(item.movie_name) + " "),
                        ]),
                        item.screen_type
                          ? _c("div", { staticClass: "tag" }, [
                              _vm._v(" " + _vm._s(item.screen_type) + " "),
                            ])
                          : _vm._e(),
                      ]),
                      _c("div", { staticClass: "introduce" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("导演: "),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(item.director)),
                        ]),
                      ]),
                      _c("div", { staticClass: "introduce" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("演员: "),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(item.actor)),
                        ]),
                      ]),
                      _c("div", { staticClass: "introduce bottom" }, [
                        _c("div", { staticClass: "score" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("评分: "),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(item.score || "暂无")),
                          ]),
                        ]),
                        _c("div", { staticClass: "btn" }, [_vm._v("购票")]),
                      ]),
                    ]),
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e(),
        _vm.activeTab === "coming" && Array.isArray(_vm.value.comingList)
          ? _c(
              "div",
              { staticClass: "movie" },
              _vm._l(_vm.value.comingList, function (item) {
                return _c(
                  "div",
                  { key: item.id, staticClass: "movieList" },
                  [
                    _c("el-image", {
                      staticClass: "img",
                      attrs: { src: item.poster_horizon },
                    }),
                    _c("div", { staticClass: "movieInfo" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(" " + _vm._s(item.movie_name) + " "),
                        ]),
                        item.screen_type
                          ? _c("div", { staticClass: "tag" }, [
                              _vm._v(" " + _vm._s(item.screen_type) + " "),
                            ])
                          : _vm._e(),
                      ]),
                      _c("div", { staticClass: "introduce" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("导演: "),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(item.director)),
                        ]),
                      ]),
                      _c("div", { staticClass: "introduce" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("演员: "),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(item.actor)),
                        ]),
                      ]),
                      _c("div", { staticClass: "introduce" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("上映时间: "),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(item.publish_time)),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e(),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }